import { useMemo } from 'react';

import { useCurrentUser } from '@portals/api/ui';
import { TenantType } from '@portals/types';

import { useAppConfig } from '../context';

export function useCurrentUserAccessibleTenants() {
  const { tenantType } = useAppConfig();
  const currentUser = useCurrentUser();

  const accessibleTenants = useMemo(() => {
    if (tenantType === TenantType.Organization) {
      return currentUser?.data?.accessible_tenants.organizations;
    } else if (tenantType === TenantType.Partner) {
      return currentUser?.data?.accessible_tenants.partners;
    }

    return undefined;
  }, [currentUser, tenantType]);

  return accessibleTenants;
}
